import uuid from 'uuid/v4';
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import ResizeAware from 'react-resize-aware';
import { cloneDeep, startCase, toLower } from 'lodash';
import DynamicDataGrid from '../common/DynamicDataGrid/DynamicDataGrid';
import DnDItemTypes from '../common/DynamicDnD/DnDItemTypes';
import * as MenuTypesOptions from '../common/MenuTypesOptions';
import AddToDefinition from '../common/AddToDefinition';
import { numberWithCommas, checkWeightType } from '../../util/CommonUtils';
import GenericButton from '../common/GenericButton';
import Modal from '../common/Modal/Modal';
import * as dictionaryActions from '../../actions/dictionaryActions';
import { GEOGRAPHY_BASES } from '../../actions/actionTypes';
import { HOTJAR_TRACKING_ENABLED } from '../../actions/urlTypes';
import { ALL, ACTION_TYPE_CRGBGRIDMENU, FLEX_STUDY_TAG,
  AUTOCODE_ACCESS_ID } from '../../constants';
import { getActionName } from '../../util/trackerUtils';
import { buildAutoCodeObject } from '../../util/autocodeUtils';
import { isAllFeaturePresent } from '../../util/CommonUtils';
import {
  getMidpointValue,
  isNielsenStudyPresent,
  filterLabel,
} from '../../util/CrosstabUtils';
import { HJ_DICTIONARY_RECYCLE_VPV } from '../../hotjarConstants';
import {
  sendVPVHotjarEvent,
  getHotjarActionName,
} from '../../util/hotjarUtils';
import FunctionBox from '../crosstab/FunctionBox/FunctionBox';

const defineModalStyle = {
  width: '50%',
  height: '250px',
  left: '27%',
  top: '30%',
};

const modalStyle = {
  width: '975px',
  height: '550px',
  left: '13%',
  top: '3%',
};

const addAfterRunCrosstabModalStyle = {
  width: '20%',
  height: 'auto',
  left: '35%',
  top: '20%',
};

const commaFormatter = ({ value }) => <div>{numberWithCommas(value)}</div>;

commaFormatter.propTypes = {
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
};

class CRBGridsV2 extends Component {
  constructor(props) {
    super(props);

    this.state = {
      crosstabRows: props.RowsDataGridData ? props.RowsDataGridData : [],
      crosstabColumns: props.ColumnsDataGridData
        ? props.ColumnsDataGridData
        : [],
      crosstabBases: props.BasesDataGridData ? props.BasesDataGridData : [],
      hoverIndex: 0,
    };
    this.columnsDataGrid = React.createRef();
    this.basesDataGrid = React.createRef();
    this.rowsDataGrid = React.createRef();
  }

  UNSAFE_componentWillMount() {
    if (this.props.allFeatures) {
      this.setState({ isAutocodePresent: isAllFeaturePresent(AUTOCODE_ACCESS_ID, this.props.allFeatures) });
    }
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    if (this.props.ColumnsDataGridData !== nextProps.ColumnsDataGridData) {
      if (
        this.props.ColumnsDataGridData &&
        nextProps.ColumnsDataGridData &&
        this.props.ColumnsDataGridData.length !==
          nextProps.ColumnsDataGridData.length
      ) {
        setTimeout(() => {
          const wrapper = $('#ColumnsDataGrid_gridType');
          wrapper
            .find('.react-grid-Canvas')
            .scrollTop(wrapper.find('.react-grid-Canvas')[0].scrollHeight);
        }, 300);
      }
      this.setState(() => ({
        crosstabColumns: nextProps.ColumnsDataGridData
          ? nextProps.ColumnsDataGridData
          : [],
      }));
    }
    if (this.props.RowsDataGridData !== nextProps.RowsDataGridData) {
      if (
        this.props.RowsDataGridData &&
        nextProps.RowsDataGridData &&
        this.props.RowsDataGridData.length !== nextProps.RowsDataGridData.length
      ) {
        setTimeout(() => {
          const wrapper = $('#RowsDataGrid_gridType');
          wrapper
            .find('.react-grid-Canvas')
            .scrollTop(wrapper.find('.react-grid-Canvas')[0].scrollHeight);
        }, 300);
      }
      this.setState(() => ({
        crosstabRows: nextProps.RowsDataGridData
          ? nextProps.RowsDataGridData
          : [],
      }));
    }

    if (this.props.BasesDataGridData !== nextProps.BasesDataGridData) {
      if (
        this.props.BasesDataGridData &&
        nextProps.BasesDataGridData &&
        this.props.BasesDataGridData.length !==
          nextProps.BasesDataGridData.length
      ) {
        setTimeout(() => {
          const wrapper = $('#BasesDataGrid_gridType');
          wrapper
            .find('.react-grid-Canvas')
            .scrollTop(wrapper.find('.react-grid-Canvas')[0].scrollHeight);
        }, 300);
      }
      this.setState(() => ({
        crosstabBases: nextProps.BasesDataGridData
          ? nextProps.BasesDataGridData
          : [],
      }));
    }

    if (
      this.props.dictionaryTarget !== nextProps.dictionaryTarget &&
      nextProps.dictionaryTarget &&
      nextProps.dictionaryTarget.status === 200 &&
      this.isTargetsDragged
    ) {
      const selectedKeywords = [];
      const selectedNames = [];
      const nielsenPresent = isNielsenStudyPresent(
        nextProps.dictionaryTarget.data
      );
      const dataSmartSearch = [];
      const breadcrumbList = JSON.parse(
        window.localStorage.getItem('breadCrumb')
      );
      const breadCrumbValue = breadcrumbList
        ? breadcrumbList.reverse().join(' > ')
        : undefined;
      for (const node of nextProps.dictionaryTarget.data) {
        const tmpDataSmartSearch = {
          expressionFormed: [],
          objectsAdded: [],
          tags: [],
          autocodenode: undefined,
        };
        if (nielsenPresent && node.rectype === 'N') {
          selectedKeywords.push(`${node.keyword} >= 1`);
        } else {
          selectedKeywords.push(node.keyword);
        }
        selectedNames.push(node.shortText);
        tmpDataSmartSearch.expressionFormed.push(node.keyword);
        node.shortTextCatgView = node.shortText.toUpperCase();
        if (breadCrumbValue) {
          node.breadcrumbs = breadCrumbValue;
        }
        tmpDataSmartSearch.objectsAdded.push(node);
        tmpDataSmartSearch.tags.push(node.shortText);
        if (this.state.isAutocodePresent) {
          tmpDataSmartSearch.autocodenode = buildAutoCodeObject(tmpDataSmartSearch.expressionFormed, 
            tmpDataSmartSearch.objectsAdded);
        }
        dataSmartSearch.push(tmpDataSmartSearch);
      }
      const titlePrefix = nextProps.dictionaryTarget.useQuestions
        ? `${nextProps.dictionaryTarget.selectedNode.shortText}: `
        : '';
      const sampleWeightedParams = {
        sourceGrid: nextProps.dictionaryTarget.componentGridCategory,
        targetGrid: nextProps.dictionaryTarget.componentGridCategory,
        token: this.props.loginResponse.data.token,
        uid: this.props.loginResponse.data.uid,
        accountId: this.props.activeAccountId,
        productNo: this.props.moduleStudy.pn,
        weightType: this.props.moduleWeigthType.wt,
        divisor: this.props.moduleWeigthType.dv,
        expressionList: selectedKeywords,
        // gridData: [...this.tmpData.latestGridEntries],
        selectedNames,
        titlePrefix,
      };
      if (this.props.breadcrumbFlag) {
        sampleWeightedParams.objSmartSearchArray = dataSmartSearch;
      }
      this.props.moduleAction.getSampleWeighted(sampleWeightedParams);
      this.isTargetsDragged = false;
      // this.tmpData = undefined;
    }
  }

  getGridColumns = titleColumnName => {
    const headers = [
      {
        key: 'title',
        name: titleColumnName,
        sortable: true,
        editable: true,
        position: 'static',
      },
    ];
    if (
      this.props.moduleStudy &&
      !this.props.moduleStudy.st.toLowerCase().includes(FLEX_STUDY_TAG)
    ) {
      headers.push({
        key: 'sample',
        name: 'Sample',
        sortable: true,
        formatter: commaFormatter,
        position: 'static',
        width: 100,
      });
      headers.push({
        key: 'weighted',
        name: `Weighted ${checkWeightType(this.props.moduleWeigthType)}`,
        sortable: true,
        formatter: commaFormatter,
        position: 'static',
        width: 140,
      });
    }

    return headers;
  };

  hoverHandle = (index, props) => {
    if (this.state.hoverFlag) {
      const hoverIndex = props.idx;
      this.setState({ hoverIndex, hoverFlag: false });
      const {
        dropItem,
        dropItemType,
        componentGridCategory,
        latestGridEntries,
      } = this.state.dropData;
      let isBaseAllowed = false;
      if (dropItemType === DnDItemTypes.DnD_ITEM_TYPE_3) {
        if (!this.props.moduleStudy.st.toLowerCase().includes(FLEX_STUDY_TAG)) {
          isBaseAllowed = true;
          const draggedItems = dropItem.selectedEntries.map(selectedEntry => ({
            id: uuid(),
            title: selectedEntry.title,
            originalTitle: selectedEntry.originalTitle,
            sample: selectedEntry.sample,
            weighted: selectedEntry.weighted,
            keyword: selectedEntry.keyword,
            rectype: selectedEntry.rectype || selectedEntry.type,
            isLabelUpdated: selectedEntry.isLabelUpdated,
            dataSmartSearch: selectedEntry.dataSmartSearch,
          }));

          const finalArray = [];

          latestGridEntries.forEach(entries => {
            let duplicateItems = false;
            draggedItems.forEach(items => {
              if (
                entries.keyword === items.keyword &&
                entries.title === items.title
              ) {
                duplicateItems = true;
              }
            });
            if (!duplicateItems) {
              finalArray.push(entries);
            }
          });
          finalArray.splice(hoverIndex, 0, ...draggedItems);
          finalArray.join();
          this.props.moduleAction.updateSampleWeighted(
            [...finalArray],
            componentGridCategory
          );
        } else if (componentGridCategory === 'BasesDataGrid') {
            if (dropItem.selectedEntries.length > 1) {
              isBaseAllowed = false;
            } else {
              let geoDataCnt = 0;
              GEOGRAPHY_BASES.map(geoData => {
                if (dropItem.selectedEntries[0].keyword.includes(geoData)) {
                  geoDataCnt += 1;
                }
              });
              if (geoDataCnt > 0 && latestGridEntries.length === 0) {
                isBaseAllowed = true;
                const draggedItems = dropItem.selectedEntries.map(
                  selectedEntry => ({
                    id: uuid(),
                    title: selectedEntry.title,
                    originalTitle: selectedEntry.originalTitle,
                    sample: selectedEntry.sample,
                    weighted: selectedEntry.weighted,
                    keyword: selectedEntry.keyword,
                    rectype: selectedEntry.rectype || selectedEntry.type,
                    isLabelUpdated: selectedEntry.isLabelUpdated,
                    dataSmartSearch: selectedEntry.dataSmartSearch,
                  })
                );

                const finalArray = [];

                latestGridEntries.forEach(entries => {
                  let duplicateItems = false;
                  draggedItems.forEach(items => {
                    if (
                      entries.keyword === items.keyword &&
                      entries.title === items.title
                    ) {
                      duplicateItems = true;
                    }
                  });
                  if (!duplicateItems) {
                    finalArray.push(entries);
                  }
                });
                finalArray.splice(hoverIndex, 0, ...draggedItems);
                finalArray.join();
                this.props.moduleAction.updateSampleWeighted(
                  [...finalArray],
                  componentGridCategory
                );
              } else {
                isBaseAllowed = false;
              }
            }
          } else {
            isBaseAllowed = true;
            const draggedItems = dropItem.selectedEntries.map(
              selectedEntry => ({
                id: uuid(),
                title: selectedEntry.title,
                originalTitle: selectedEntry.originalTitle,
                sample: selectedEntry.sample,
                weighted: selectedEntry.weighted,
                keyword: selectedEntry.keyword,
                rectype: selectedEntry.rectype || selectedEntry.type,
                isLabelUpdated: selectedEntry.isLabelUpdated,
                dataSmartSearch: selectedEntry.dataSmartSearch,
              })
            );
            const finalArray = [];

            latestGridEntries.forEach(entries => {
              let duplicateItems = false;
              draggedItems.forEach(items => {
                if (
                  entries.keyword === items.keyword &&
                  entries.title === items.title
                ) {
                  duplicateItems = true;
                }
              });
              if (!duplicateItems) {
                finalArray.push(entries);
              }
            });
            finalArray.splice(hoverIndex, 0, ...draggedItems);
            finalArray.join();
            this.props.moduleAction.updateSampleWeighted(
              [...finalArray],
              componentGridCategory
            );
          }
      }
      if (!isBaseAllowed) {
        this.addAfterRunCrosstabModal.show();
      }
    }
  };

  /* buildAutoCodeDictionaryNode = (node, combine=false, labelOverride='') => {
    const labels = [];
    const splitData = node.shortText.split(':');
    const breadCrumbs = node.breadcrumbs ? node.breadcrumbs.split(' > ') : [];
    if (node.breadcrumbs) {
      for(let i = 0; i < breadCrumbs.length - 1; i+=1) {
        labels[i] = breadCrumbs[i];
      }
      if (splitData.length === 2 && splitData[1] !== '') {
        labels[breadCrumbs.length-1] = toLower(splitData[0]);
        labels[breadCrumbs.length] = toLower(splitData[1]);
      } else {
        labels[breadCrumbs.length-1] = toLower(breadCrumbs[breadCrumbs.length-1]);
        labels[breadCrumbs.length] = toLower(splitData[0]);
      }
    }

    const autocode = {
      id: uuid(),
      type: 'dictionary',
      selected: false,
      combine,
      useLabelOverride: node.isLabelUpdated,
      labelOverride,
      group: 0,
      children: [],
      rootnodeChild: "root",
      data: {
        labels,
        nodeLabel: splitData[0],
        keyword: node.keyword,
        midpoint: node.midpoint,
        modeled: node.modeled,
        node: node.node,
        objectType: node.objectType,
        pathId: node.pathId,
        recordType: node.recordType,
        rectype: node.rectype,
        shortText: node.shortText,
        shortTextCatgView: splitData[1],
        textPath: node.textPath,
        uniqueId: node.uniqueId
      }
    };
    return autocode;
  } */

  buildAutoCodeDefinitionNode = (node, combine=false, labelOverride='') => {
    const autocode = {
      id: uuid(),
      type: 'definition',
      selected: false,
      combine,
      useLabelOverride: node.isLabelUpdated,
      labelOverride,
      group: 0,
      children: [],
      rootnodeChild: "root",
      data: {
        expressionId: node.expressionId,
        ovDefinitionId: node.ovDefinitionId,
        title: node.title,
        expression: node.expression,
        lastModified:node.lastModified,
        shortTextCatgView: node.title,
      }
    };
    return autocode;
  }

  handleGridDrop = (
    dropItems,
    dropItemType,
    componentGridCategory,
    latestGridEntries
  ) => {
    setTimeout(() => {
      const wrapper = $(`#${componentGridCategory}_gridType`);
      wrapper
        .find('.react-grid-Canvas')
        .scrollTop(wrapper.find('.react-grid-Canvas')[0].scrollHeight);
    }, 1000);

    const dropItem = cloneDeep(dropItems);
    // Hotjar event calls for Recycle items
    if (
      HOTJAR_TRACKING_ENABLED &&
      dropItem &&
      dropItem.gridCategory === 'RecycleGrid' &&
      (componentGridCategory === 'BasesDataGrid' ||
        componentGridCategory === 'ColumnsDataGrid' ||
        componentGridCategory === 'RowsDataGrid')
    ) {
      const hjAction = getHotjarActionName(
        HJ_DICTIONARY_RECYCLE_VPV,
        componentGridCategory
      );
      sendVPVHotjarEvent(`${HJ_DICTIONARY_RECYCLE_VPV}/${hjAction}`);
    }
    const breadcrumbList = JSON.parse(
      window.localStorage.getItem('breadCrumb')
    );
    const breadCrumbValue = breadcrumbList
      ? breadcrumbList.reverse().join(' > ')
      : undefined;
    let isBaseAllowed = false;
    if (dropItemType === DnDItemTypes.DnD_ITEM_TYPE_1) {
      this.isTargetsDragged = true;
      if (!this.props.moduleStudy.st.toLowerCase().includes('slcl')) {
        isBaseAllowed = true;
        this.props.dictionaryActions.getDictionaryTargetLoad(
          this.props.loginResponse.data.token,
          this.props.loginResponse.data.uid,
          this.props.activeAccountId,
          this.props.moduleStudy.pn,
          dropItem.selectedNode.node
            ? dropItem.selectedNode.node
            : dropItem.selectedNode.recno,
          ALL,
          dropItem.selectedNode,
          dropItem.useQuestions,
          componentGridCategory
        );
      } else if (componentGridCategory === 'BasesDataGrid') {
        isBaseAllowed = false;
      } else {
        isBaseAllowed = true;
        /* this.tmpData = {
          selectedNode: dropItem.selectedNode,
          useQuestions: dropItem.useQuestions,
          componentGridCategory,
          latestGridEntries,
        }; */
        this.props.dictionaryActions.getDictionaryTargetLoad(
          this.props.loginResponse.data.token,
          this.props.loginResponse.data.uid,
          this.props.activeAccountId,
          this.props.moduleStudy.pn,
          dropItem.selectedNode.node,
          ALL,
          dropItem.selectedNode,
          dropItem.useQuestions,
          componentGridCategory
        );
      }
      if (!isBaseAllowed) {
        this.addAfterRunCrosstabModal.show();
      }
    } else if (
      dropItemType === DnDItemTypes.DnD_ITEM_TYPE_2 ||
      dropItemType === DnDItemTypes.DnD_ITEM_TYPE_4 ||
      dropItemType === DnDItemTypes.DnD_ITEM_TYPE_7
    ) {
      const selectedKeywords = [];
      const selectedNames = [];
      const dataSmartSearch = [];
      const isLabelUpdated = [];

      if (dropItemType === DnDItemTypes.DnD_ITEM_TYPE_2) {
        if (!this.props.moduleStudy.st.toLowerCase().includes('slcl')) {
          isBaseAllowed = true;
          for (const node of dropItem.selectedNodes) {
            const tmpDataSmartSearch = {
              expressionFormed: [],
              objectsAdded: [],
              tags: [],
              autocodenode: undefined,
            };
            node.breadcrumbs = breadCrumbValue;
            selectedKeywords.push(node.keyword);
            selectedNames.push(node.shortText);
            tmpDataSmartSearch.expressionFormed.push(node.keyword);
            tmpDataSmartSearch.objectsAdded.push(node);
            tmpDataSmartSearch.tags.push(node.shortText);
            if (this.state.isAutocodePresent) {
              tmpDataSmartSearch.autocodenode =
                buildAutoCodeObject(tmpDataSmartSearch.expressionFormed, 
                                tmpDataSmartSearch.objectsAdded);
            }
            dataSmartSearch.push(tmpDataSmartSearch);
            isLabelUpdated.push(node.isLabelUpdated);
          }
        } else if (componentGridCategory === 'BasesDataGrid') {
          isBaseAllowed = false;
        } else {
          isBaseAllowed = true;
          for (const node of dropItem.selectedNodes) {
            const tmpDataSmartSearch = {
              expressionFormed: [],
              objectsAdded: [],
              tags: [],
              autocodenode: undefined,
            };
            node.breadcrumbs = breadCrumbValue;
            selectedKeywords.push(node.keyword);
            selectedNames.push(node.shortText);
            tmpDataSmartSearch.expressionFormed.push(node.keyword);
            tmpDataSmartSearch.objectsAdded.push(node);
            tmpDataSmartSearch.tags.push(node.shortText);
            if (this.state.isAutocodePresent) {
              tmpDataSmartSearch.autocodenode = buildAutoCodeObject(tmpDataSmartSearch.expressionFormed, 
                tmpDataSmartSearch.objectsAdded);
              }
            dataSmartSearch.push(tmpDataSmartSearch);
            isLabelUpdated.push(node.isLabelUpdated);
          }
        }
      } else if (dropItemType === DnDItemTypes.DnD_ITEM_TYPE_7) {
        if (
          componentGridCategory === 'BasesDataGrid' &&
          latestGridEntries.length > 0
        ) {
          isBaseAllowed = false;
        } else {
          isBaseAllowed = true;
        }
        if (isBaseAllowed) {
          for (const key in dropItem.selectedNodes) {
            if (
              dropItem.selectedNodes[key].length > 1 &&
              componentGridCategory === 'BasesDataGrid'
            ) {
              isBaseAllowed = false;
              break;
            }
            isBaseAllowed = true;
            dropItem.selectedNodes[key].forEach(data => {
              const tmpDataSmartSearch = {
                expressionFormed: [],
                objectsAdded: [],
                tags: [],
                autocodenode: undefined,
              };
              const geoBreadCrumb = `Geographies > ${data.fname.substring(
                2,
                data.fname.length
              )}`;
              data.breadcrumbs = geoBreadCrumb;
              data.shortTextCatgView = data.name.toUpperCase();
              selectedNames.push(data.name);
              selectedKeywords.push(`${key} ( ${data.nodeId} )`);
              tmpDataSmartSearch.expressionFormed.push(
                `${key} ( ${data.nodeId} )`
              );
              tmpDataSmartSearch.objectsAdded.push(data);
              tmpDataSmartSearch.tags.push(data.name);
              if (this.state.isAutocodePresent) {
                tmpDataSmartSearch.autocodenode = buildAutoCodeObject(tmpDataSmartSearch.expressionFormed, 
                  tmpDataSmartSearch.objectsAdded);
              }
              dataSmartSearch.push(tmpDataSmartSearch);
              isLabelUpdated.push(data.isLabelUpdated);
            });
          }
        }
      } else if (!this.props.moduleStudy.st.toLowerCase().includes('slcl')) {
          isBaseAllowed = true;
          for (const node of dropItem.selectedNodes) {
            const tmpDataSmartSearch = {
              expressionFormed: [],
              objectsAdded: [],
              tags: [],
              autocodenode: undefined,
            };
            node.breadcrumbs = breadCrumbValue;
            node.shortTextCatgView = node.title;
            selectedKeywords.push(node.expression);
            selectedNames.push(node.title);
            tmpDataSmartSearch.expressionFormed.push(node.expression);
            tmpDataSmartSearch.objectsAdded.push(node);
            tmpDataSmartSearch.tags.push(node.title);
            if (this.state.isAutocodePresent) {
              tmpDataSmartSearch.autocodenode = this.buildAutoCodeDefinitionNode(node);
              }
            dataSmartSearch.push(tmpDataSmartSearch);
            isLabelUpdated.push(node.isLabelUpdated);
          }
        } else if (
            componentGridCategory === 'BasesDataGrid' &&
            latestGridEntries.length > 0 &&
            dropItem.selectedNodes.length > 1
          ) {
            isBaseAllowed = false;
          } else if (
            componentGridCategory === 'BasesDataGrid' &&
            latestGridEntries.length === 0 &&
            dropItem.selectedNodes.length > 1
          ) {
            isBaseAllowed = false;
          } else if (componentGridCategory !== 'BasesDataGrid') {
              isBaseAllowed = true;
              for (const node of dropItem.selectedNodes) {
                const tmpDataSmartSearch = {
                  expressionFormed: [],
                  objectsAdded: [],
                  tags: [],
                  autocodenode: undefined,
                };
                node.breadcrumbs = breadCrumbValue;
                selectedKeywords.push(node.expression);
                selectedNames.push(node.title);
                tmpDataSmartSearch.expressionFormed.push(node.expression);
                tmpDataSmartSearch.objectsAdded.push(node);
                tmpDataSmartSearch.tags.push(node.title);
                if (this.state.isAutocodePresent) {
                  tmpDataSmartSearch.autocodenode = buildAutoCodeObject(tmpDataSmartSearch.expressionFormed, 
                    tmpDataSmartSearch.objectsAdded);
                }
                dataSmartSearch.push(tmpDataSmartSearch);
                isLabelUpdated.push(node.isLabelUpdated);
              }
            } else {
              isBaseAllowed = true;
              for (const node of dropItem.selectedNodes) {
                const tmpDataSmartSearch = {
                  expressionFormed: [],
                  objectsAdded: [],
                  tags: [],
                  autocodenode: undefined,
                };
                node.breadcrumbs = breadCrumbValue;
                selectedKeywords.push(node.expression);
                selectedNames.push(node.title);
                tmpDataSmartSearch.expressionFormed.push(node.expression);
                tmpDataSmartSearch.objectsAdded.push(node);
                tmpDataSmartSearch.tags.push(node.title);
                if (this.state.isAutocodePresent) {
                  tmpDataSmartSearch.autocodenode = buildAutoCodeObject(tmpDataSmartSearch.expressionFormed, 
                    tmpDataSmartSearch.objectsAdded);
                }
                dataSmartSearch.push(tmpDataSmartSearch);
                isLabelUpdated.push(node.isLabelUpdated);
              }
            }
      if (isBaseAllowed) {
        const nielsenPresent = isNielsenStudyPresent(dropItem.selectedNodes);
        if (dropItem.selectedNodes.constructor === Array) {
          dropItem.selectedNodes.forEach((item, index) => {
            if (nielsenPresent && item.rectype === 'N') {
              selectedKeywords[index] = `${selectedKeywords[index]} >= 1`;
            }
          });
        }
        const sampleWeightedParams = {
          sourceGrid: componentGridCategory,
          targetGrid: componentGridCategory,
          token: this.props.loginResponse.data.token,
          uid: this.props.loginResponse.data.uid,
          accountId: this.props.activeAccountId,
          productNo: this.props.moduleStudy.pn,
          weightType: this.props.moduleWeigthType.wt,
          divisor: this.props.moduleWeigthType.dv,
          expressionList: selectedKeywords,
          gridData: latestGridEntries,
          selectedNames,
          isLabelUpdated,
        };
        if (this.props.breadcrumbFlag) {
          sampleWeightedParams.objSmartSearchArray = dataSmartSearch;
        }
        let kpiNotExistsFlag = false;
        const responseData = [];
        selectedKeywords.forEach(elems => {
          if (this.props.sampleWeightedKPIs[elems] === undefined) {
            kpiNotExistsFlag = true;
          } else {
            responseData.push(this.props.sampleWeightedKPIs[elems].data[0]);
          }
        });
        if (kpiNotExistsFlag) {
          this.props.moduleAction.getSampleWeighted(sampleWeightedParams);
        } else {
          sampleWeightedParams.response = responseData;
          this.props.moduleAction.getSampleWeightedData(sampleWeightedParams);
        }
      }
      if (!isBaseAllowed) {
        this.addAfterRunCrosstabModal.show();
      }
    } else if (dropItemType === DnDItemTypes.DnD_ITEM_TYPE_3) {
      this.setState({
        hoverFlag: true,
        dropData: {
          dropItem,
          dropItemType,
          componentGridCategory,
          latestGridEntries,
        },
      });
    }
  };

  handleColumnGridSelectionChange = sortDirection => {
    const selectedRows = this.columnsDataGrid.current.decoratedRef.current.getSelectedEntries();
    let isColumnGridUpBtn = false;
    let isColumnGridDownBtn = false;
    if (
      selectedRows.length === 1 &&
      this.state.crosstabColumns &&
      sortDirection !== 'ASC' &&
      sortDirection !== 'DESC'
    ) {
      if (selectedRows[0].id !== this.state.crosstabColumns[0].id) {
        isColumnGridUpBtn = true;
      }
      if (
        selectedRows[0].id !==
        this.state.crosstabColumns[this.state.crosstabColumns.length - 1].id
      ) {
        isColumnGridDownBtn = true;
      }
    }
    this.setState({ isColumnGridUpBtn, isColumnGridDownBtn });
  };

  handleColumnGridUpDownBtn = posUpdate => {
    // TODO: scrollIntoView or scroll top
    const columnsDataGridObj = this.columnsDataGrid.current.decoratedRef
      .current;
    const crosstabColumns = [...this.props.ColumnsDataGridData];
    const oldIndex = crosstabColumns.findIndex(
      element => element.id === columnsDataGridObj.getSelectedEntries()[0].id
    );
    const selectedEntry = crosstabColumns.splice(oldIndex, 1)[0];
    crosstabColumns.splice(oldIndex + posUpdate, 0, selectedEntry);
    columnsDataGridObj.storeMovedRowId(selectedEntry.id);
    this.props.moduleAction.updateSampleWeighted(
      crosstabColumns,
      'ColumnsDataGrid'
    );
  };

  handleRowGridSelectionChange = sortDirection => {
    const selectedRows = this.rowsDataGrid.current.decoratedRef.current.getSelectedEntries();
    let isRowGridUpBtn = false;
    let isRowGridDownBtn = false;
    if (
      selectedRows.length === 1 &&
      this.state.crosstabRows &&
      sortDirection !== 'ASC' &&
      sortDirection !== 'DESC'
    ) {
      if (selectedRows[0].id !== this.state.crosstabRows[0].id) {
        isRowGridUpBtn = true;
      }
      if (
        selectedRows[0].id !==
        this.state.crosstabRows[this.state.crosstabRows.length - 1].id
      ) {
        isRowGridDownBtn = true;
      }
    }
    this.setState({ isRowGridUpBtn, isRowGridDownBtn });
  };

  handleRowGridUpDownBtn = posUpdate => {
    // TODO: scrollIntoView or scroll top
    const rowsDataGridObj = this.rowsDataGrid.current.decoratedRef.current;
    const crosstabRows = [...this.props.RowsDataGridData];
    const oldIndex = crosstabRows.findIndex(
      element => element.id === rowsDataGridObj.getSelectedEntries()[0].id
    );
    const selectedEntry = crosstabRows.splice(oldIndex, 1)[0];
    crosstabRows.splice(oldIndex + posUpdate, 0, selectedEntry);
    rowsDataGridObj.storeMovedRowId(selectedEntry.id);
    this.props.moduleAction.updateSampleWeighted(crosstabRows, 'RowsDataGrid');
  };

  handleBaseGridSelectionChange = sortDirection => {
    const selectedRows = this.basesDataGrid.current.decoratedRef.current.getSelectedEntries();
    let isbaseGridUpBtn = false;
    let isbaseGridDownBtn = false;
    if (
      selectedRows.length === 1 &&
      this.state.crosstabBases &&
      sortDirection !== 'ASC' &&
      sortDirection !== 'DESC'
    ) {
      if (selectedRows[0].id !== this.state.crosstabBases[0].id) {
        isbaseGridUpBtn = true;
      }
      if (
        selectedRows[0].id !==
        this.state.crosstabBases[this.state.crosstabBases.length - 1].id
      ) {
        isbaseGridDownBtn = true;
      }
    }
    this.setState({ isbaseGridUpBtn, isbaseGridDownBtn });
  };

  handleBaseGridUpDownBtn = posUpdate => {
    // TODO: scrollIntoView or scroll top
    const basesDataGridObj = this.basesDataGrid.current.decoratedRef.current;
    const crosstabBases = [...this.props.BasesDataGridData];
    const oldIndex = crosstabBases.findIndex(
      element => element.id === basesDataGridObj.getSelectedEntries()[0].id
    );
    const selectedEntry = crosstabBases.splice(oldIndex, 1)[0];
    crosstabBases.splice(oldIndex + posUpdate, 0, selectedEntry);
    basesDataGridObj.storeMovedRowId(selectedEntry.id);
    this.props.moduleAction.updateSampleWeighted(
      crosstabBases,
      'BasesDataGrid'
    );
  };

  // Context Menu Handlers
  handleContextMenuOptions = (option, sourceGrid) => {
    const {
      FUNCTIONS,
      ADD_DEFINITION,
      DELETE_COLUMNS,
      DELETE_ROWS,
      SELECT_ALL,
      COPY_TO_COLUMNS,
      COPY_TO_ROWS,
      COPY_TO_BASES,
      COPY_TO_SCRATCH,
      MOVE_TO_COLUMNS,
      MOVE_TO_ROWS,
      MOVE_TO_BASES,
      MOVE_TO_SCRATCH,
    } = MenuTypesOptions.CONTEXT_MENU_OPTIONS;
    const breadcrumbList = JSON.parse(
      window.localStorage.getItem('breadCrumb')
    );
    const breadCrumbValue = breadcrumbList
      ? breadcrumbList.reverse().join(' > ')
      : undefined;
    const crosstabBases = this.props.BasesDataGridData
      ? this.props.BasesDataGridData
      : [];
    const crosstabScratch = this.props.ScratchDataGridData
      ? this.props.ScratchDataGridData
      : [];
    const recycleElements = this.props.recycleElements
      ? this.props.recycleElements
      : [];

    let selectedEntries;

    if (option === FUNCTIONS) {
      selectedEntries = (sourceGrid === 'ColumnsDataGrid'
        ? this.columnsDataGrid
        : this.rowsDataGrid
      ).current.decoratedRef.current
        .getSelectedEntries()
        .map(selectedEntry => ({
          shortText: selectedEntry.title,
          keyword: selectedEntry.keyword,
          midpoint:
            selectedEntry.dataSmartSearch &&
            selectedEntry.dataSmartSearch.objectsAdded &&
            selectedEntry.dataSmartSearch.objectsAdded[0]
              ? getMidpointValue(
                  selectedEntry.keyword,
                  selectedEntry.dataSmartSearch.objectsAdded
                ).midpoint
              : 0,
          breadcrumbs: breadCrumbValue,
          isLabelUpdated: selectedEntry.isLabelUpdated,
        }));
    } else {
      selectedEntries = (sourceGrid === 'ColumnsDataGrid'
        ? this.columnsDataGrid
        : this.rowsDataGrid
      ).current.decoratedRef.current
        .getSelectedEntries()
        .map(selectedEntry => ({
          id: uuid(),
          title: selectedEntry.title,
          originalTitle: selectedEntry.originalTitle,
          sample: selectedEntry.sample,
          weighted: selectedEntry.weighted,
          keyword: selectedEntry.keyword,
          rectype: selectedEntry.rectype,
          dataSmartSearch: selectedEntry.dataSmartSearch,
          breadcrumbs: breadCrumbValue,
          isLabelUpdated: selectedEntry.isLabelUpdated,
        }));
    }

    const action = getActionName(ACTION_TYPE_CRGBGRIDMENU, option);
    if (selectedEntries.length > 0 && action !== '') {
      this.props.trackerFn({
        action,
        attributes: { expression: selectedEntries },
      });
    }
    switch (option) {
      case FUNCTIONS:
        this.setState({ selectedTargets: selectedEntries }, () =>
          this.functionBoxModal.show()
        );
        break;
      case ADD_DEFINITION:
        this.setState({
          addToDefinition: (sourceGrid === 'ColumnsDataGrid'
            ? this.columnsDataGrid
            : this.rowsDataGrid
          ).current.decoratedRef.current
            .getSelectedEntries()
            .map(({ title, keyword }) => ({
              id: 0,
              name: title,
              expression: keyword,
            })),
        });
        this.addToDefinition.show();
        break;
      case DELETE_COLUMNS:
        this.props.moduleAction.updateSampleWeighted(
          [...selectedEntries, ...recycleElements],
          'RecycleGrid'
        );
        this.props.moduleAction.updateSampleWeighted(
          this.columnsDataGrid.current.decoratedRef.current.getUnselectedEntries(),
          'ColumnsDataGrid'
        );
        break;
      case DELETE_ROWS:
        this.props.moduleAction.updateSampleWeighted(
          [...selectedEntries, ...recycleElements],
          'RecycleGrid'
        );
        this.props.moduleAction.updateSampleWeighted(
          this.rowsDataGrid.current.decoratedRef.current.getUnselectedEntries(),
          'RowsDataGrid'
        );
        break;
      case SELECT_ALL:
        if (sourceGrid === 'RowsDataGrid') {
          this.rowsDataGrid.current.decoratedRef.current.selectAllEntries();
        } else if (sourceGrid === 'ColumnsDataGrid') {
          this.columnsDataGrid.current.decoratedRef.current.selectAllEntries();
        }
        break;
      case COPY_TO_COLUMNS:
        this.props.moduleAction.updateSampleWeighted(
          [...this.state.crosstabColumns, ...selectedEntries],
          'ColumnsDataGrid'
        );
        break;
      case COPY_TO_ROWS:
        this.props.moduleAction.updateSampleWeighted(
          [...this.state.crosstabRows, ...selectedEntries],
          'RowsDataGrid'
        );
        break;
      case COPY_TO_BASES:
        if (!this.props.moduleStudy.st.toLowerCase().includes(FLEX_STUDY_TAG)) {
          this.props.moduleAction.updateSampleWeighted(
            [...crosstabBases, ...selectedEntries],
            'BasesDataGrid'
          );
        } else if (crosstabBases.length > 0 || selectedEntries.length > 1) {
            this.addAfterRunCrosstabModal.show();
          } else {
            const isGeographyBase = GEOGRAPHY_BASES.some(base =>
              selectedEntries[0].keyword.includes(base)
            );
            if (isGeographyBase) {
              this.props.moduleAction.updateSampleWeighted(
                [...crosstabBases, ...selectedEntries],
                'BasesDataGrid'
              );
            } else {
              this.addAfterRunCrosstabModal.show();
            }
          }
        break;
      case COPY_TO_SCRATCH:
        this.props.moduleAction.updateSampleWeighted(
          [...crosstabScratch, ...selectedEntries],
          'ScratchDataGrid'
        );
        break;
      case MOVE_TO_COLUMNS:
        this.props.moduleAction.updateSampleWeighted(
          [...this.state.crosstabColumns, ...selectedEntries],
          'ColumnsDataGrid'
        );
        this.props.moduleAction.updateSampleWeighted(
          this.rowsDataGrid.current.decoratedRef.current.getUnselectedEntries(),
          'RowsDataGrid'
        );
        break;
      case MOVE_TO_ROWS:
        this.props.moduleAction.updateSampleWeighted(
          [...this.state.crosstabRows, ...selectedEntries],
          'RowsDataGrid'
        );
        this.props.moduleAction.updateSampleWeighted(
          this.columnsDataGrid.current.decoratedRef.current.getUnselectedEntries(),
          'ColumnsDataGrid'
        );
        break;
      case MOVE_TO_BASES:
        if (!this.props.moduleStudy.st.toLowerCase().includes(FLEX_STUDY_TAG)) {
          this.props.moduleAction.updateSampleWeighted(
            [...crosstabBases, ...selectedEntries],
            'BasesDataGrid'
          );
          if (sourceGrid === 'RowsDataGrid') {
            this.props.moduleAction.updateSampleWeighted(
              this.rowsDataGrid.current.decoratedRef.current.getUnselectedEntries(),
              'RowsDataGrid'
            );
          } else if (sourceGrid === 'ColumnsDataGrid') {
            this.props.moduleAction.updateSampleWeighted(
              this.columnsDataGrid.current.decoratedRef.current.getUnselectedEntries(),
              'ColumnsDataGrid'
            );
          }
          break;
        } else if (crosstabBases.length > 0 || selectedEntries.length > 1) {
            this.addAfterRunCrosstabModal.show();
            break;
          } else {
            const isGeographyBase = GEOGRAPHY_BASES.some(base =>
              selectedEntries[0].keyword.includes(base)
            );
            if (isGeographyBase) {
              this.props.moduleAction.updateSampleWeighted(
                [...crosstabBases, ...selectedEntries],
                'BasesDataGrid'
              );
              if (sourceGrid === 'RowsDataGrid') {
                this.props.moduleAction.updateSampleWeighted(
                  this.rowsDataGrid.current.decoratedRef.current.getUnselectedEntries(),
                  'RowsDataGrid'
                );
              } else if (sourceGrid === 'ColumnsDataGrid') {
                this.props.moduleAction.updateSampleWeighted(
                  this.columnsDataGrid.current.decoratedRef.current.getUnselectedEntries(),
                  'ColumnsDataGrid'
                );
              }
              break;
            } else {
              this.addAfterRunCrosstabModal.show();
              break;
            }
          }
      case MOVE_TO_SCRATCH:
        this.props.moduleAction.updateSampleWeighted(
          [...crosstabScratch, ...selectedEntries],
          'ScratchDataGrid'
        );
        if (sourceGrid === 'RowsDataGrid') {
          this.props.moduleAction.updateSampleWeighted(
            this.rowsDataGrid.current.decoratedRef.current.getUnselectedEntries(),
            'RowsDataGrid'
          );
        } else if (sourceGrid === 'ColumnsDataGrid') {
          this.props.moduleAction.updateSampleWeighted(
            this.columnsDataGrid.current.decoratedRef.current.getUnselectedEntries(),
            'ColumnsDataGrid'
          );
        }
        break;
      default:
        return null;
    }
    return null;
  };

  // Context Menu Handlers
  // TODO: Merge 2 functions
  handleContextMenuOptionsTmp = option => {
    const {
      FUNCTIONS,
      ADD_DEFINITION,
      DELETE_BASES,
      SELECT_ALL,
      COPY_TO_COLUMNS,
      COPY_TO_ROWS,
      COPY_TO_SCRATCH,
      MOVE_TO_COLUMNS,
      MOVE_TO_ROWS,
      MOVE_TO_SCRATCH,
    } = MenuTypesOptions.CONTEXT_MENU_OPTIONS;
    const breadcrumbList = JSON.parse(
      window.localStorage.getItem('breadCrumb')
    );
    const breadCrumbValue = breadcrumbList
      ? breadcrumbList.reverse().join(' > ')
      : undefined;
    const crosstabRows = this.props.RowsDataGridData
      ? this.props.RowsDataGridData
      : [];
    const crosstabColumns = this.props.ColumnsDataGridData
      ? this.props.ColumnsDataGridData
      : [];
    const crosstabScratch = this.props.ScratchDataGridData
      ? this.props.ScratchDataGridData
      : [];
    const recycleElements = this.props.recycleElements
      ? this.props.recycleElements
      : [];

    let selectedEntries;

    if (option === FUNCTIONS) {
      selectedEntries = this.basesDataGrid.current.decoratedRef.current
        .getSelectedEntries()
        .map(selectedEntry => ({
          shortText: selectedEntry.title,
          keyword: selectedEntry.keyword,
          midpoint:
            selectedEntry.dataSmartSearch &&
            selectedEntry.dataSmartSearch.objectsAdded &&
            selectedEntry.dataSmartSearch.objectsAdded[0]
              ? getMidpointValue(
                  selectedEntry.keyword,
                  selectedEntry.dataSmartSearch.objectsAdded
                ).midpoint
              : 0,
          breadcrumbs: breadCrumbValue,
          isLabelUpdated: selectedEntry.isLabelUpdated,
        }));
    } else {
      selectedEntries = this.basesDataGrid.current.decoratedRef.current
        .getSelectedEntries()
        .map(selectedEntry => ({
          id: uuid(),
          title: selectedEntry.title,
          originalTitle: selectedEntry.originalTitle,
          sample: selectedEntry.sample,
          weighted: selectedEntry.weighted,
          keyword: selectedEntry.keyword,
          rectype: selectedEntry.rectype,
          dataSmartSearch: selectedEntry.dataSmartSearch,
          breadcrumbs: breadCrumbValue,
          isLabelUpdated: selectedEntry.isLabelUpdated,
        }));
    }

    const action = getActionName(ACTION_TYPE_CRGBGRIDMENU, option);
    if (selectedEntries.length > 0 && action !== '') {
      this.props.trackerFn({
        action,
        attributes: { expression: selectedEntries },
      });
    }

    switch (option) {
      case FUNCTIONS:
        this.setState({ selectedTargets: selectedEntries }, () =>
          this.functionBoxModal.show()
        );
        break;
      case ADD_DEFINITION:
        this.setState({
          addToDefinition: this.basesDataGrid.current.decoratedRef.current
            .getSelectedEntries()
            .map(({ title, keyword }) => ({
              id: 0,
              name: title,
              expression: keyword,
            })),
        });
        this.addToDefinition.show();
        break;
      case DELETE_BASES:
        this.props.moduleAction.updateSampleWeighted(
          [...selectedEntries, ...recycleElements],
          'RecycleGrid'
        );
        this.props.moduleAction.updateSampleWeighted(
          this.basesDataGrid.current.decoratedRef.current.getUnselectedEntries(),
          'BasesDataGrid'
        );
        break;
      case SELECT_ALL:
        this.basesDataGrid.current.decoratedRef.current.selectAllEntries();
        break;
      case COPY_TO_COLUMNS:
        this.props.moduleAction.updateSampleWeighted(
          [...crosstabColumns, ...selectedEntries],
          'ColumnsDataGrid'
        );
        break;
      case COPY_TO_ROWS:
        this.props.moduleAction.updateSampleWeighted(
          [...crosstabRows, ...selectedEntries],
          'RowsDataGrid'
        );
        break;
      case COPY_TO_SCRATCH:
        this.props.moduleAction.updateSampleWeighted(
          [...crosstabScratch, ...selectedEntries],
          'ScratchDataGrid'
        );
        break;
      case MOVE_TO_COLUMNS:
        this.props.moduleAction.updateSampleWeighted(
          [...crosstabColumns, ...selectedEntries],
          'ColumnsDataGrid'
        );
        this.props.moduleAction.updateSampleWeighted(
          this.basesDataGrid.current.decoratedRef.current.getUnselectedEntries(),
          'BasesDataGrid'
        );
        break;
      case MOVE_TO_ROWS:
        this.props.moduleAction.updateSampleWeighted(
          [...crosstabRows, ...selectedEntries],
          'RowsDataGrid'
        );
        this.props.moduleAction.updateSampleWeighted(
          this.basesDataGrid.current.decoratedRef.current.getUnselectedEntries(),
          'BasesDataGrid'
        );
        break;
      case MOVE_TO_SCRATCH:
        this.props.moduleAction.updateSampleWeighted(
          [...crosstabScratch, ...selectedEntries],
          'ScratchDataGrid'
        );
        this.props.moduleAction.updateSampleWeighted(
          this.basesDataGrid.current.decoratedRef.current.getUnselectedEntries(),
          'BasesDataGrid'
        );
        break;
      default:
        return null;
    }
    return null;
  };

  handleCRBGridsResize = dimensions => {
    this.setState({ CRBGridsWidth: dimensions.width });
  };

  updateCrosstabTitleHeader = updatedData => {
    let gridCategory = '';
    let originalList = [];
    let index = 0;
    switch (updatedData.gridCategory) {
      case 'ColumnsDataGrid':
        gridCategory = 'column';
        break;
      case 'RowsDataGrid':
        gridCategory = 'row';
        break;
      case 'BasesDataGrid':
        gridCategory = 'base';
        break;
      default:
        gridCategory = '';
    }
    if (gridCategory !== '' && gridCategory === 'column') {
      originalList = this.props.ColumnsDataGridData;
    } else if (gridCategory !== '' && gridCategory === 'row') {
      originalList = this.props.RowsDataGridData;
    } else if (gridCategory !== '' && gridCategory === 'base') {
      originalList = this.props.BasesDataGridData;
    }
    if (originalList.length !== 0) {
      index = originalList.findIndex(item => {
        if (item.keyword === updatedData.keyword) {
          return true;
        }
        return false;
      });
      updatedData.index = index;
    }
    updatedData.keyword = originalList[index].keyword;
    const dataSmartSearch = originalList[index].dataSmartSearch;
    const oldLabel = filterLabel(`${dataSmartSearch.objectsAdded[0].shortTextCatgView}`, 
    `${dataSmartSearch.objectsAdded[0].breadcrumbs}`);
    const isLabelUpdated = !(oldLabel === updatedData.updatedTitle);
    updatedData = {
      ...updatedData,
      isLabelUpdated,
    };
    this.props.moduleAction.updateCrosstabGridTitleHeader(updatedData);
  };

  getBaseMenuOptions = () => {
    if (this.props.scratchEnabled) {
      return MenuTypesOptions.CONTEXT_MENU_TYPES.BASES;
    }
    return MenuTypesOptions.CONTEXT_MENU_TYPES.BASES_WITHOUT_SCRATCH;
  };

  getColumnMenuOptions = () => {
    if (this.props.scratchEnabled) {
      return MenuTypesOptions.CONTEXT_MENU_TYPES.COLUMNS;
    }
    return MenuTypesOptions.CONTEXT_MENU_TYPES.COLUMNS_WITHOUT_SCRATCH;
  };

  getRowMenuOptions = () => {
    if (this.props.scratchEnabled) {
      return MenuTypesOptions.CONTEXT_MENU_TYPES.ROWS;
    }
    return MenuTypesOptions.CONTEXT_MENU_TYPES.ROWS_WITHOUT_SCRATCH;
  };

  render() {
    return (
      <div>
        <div>
          <div className="position-relative">
            <h5 className="dictionary-grids-header counter-header">
              <span
                className="grid-count left-position-bases"
                style={{
                  padding:
                    this.state.crosstabBases.length < 10 ? '1.5px 3px' : '2px',
                }}
              >
                {this.state.crosstabBases.length}
              </span>
            </h5>
            <h5 className="cross-img-container counter-header">
              <button
                className={`cross-img ${
                  this.state.crosstabBases.length !== 0 ? '' : 'image-disable'
                }`}
                onClick={() =>
                  this.props.moduleAction.clearSampleWeighted('BasesDataGrid')
                }
                disabled={this.state.crosstabBases.length === 0}
              />
              {this.props.moduleStudy &&
                !this.props.moduleStudy.st
                  .toLowerCase()
                  .includes(FLEX_STUDY_TAG) && (
                  <button
                    className={`grid-down-arrow-img ${
                      this.state.isbaseGridDownBtn ? '' : 'image-disable'
                    }`}
                    onClick={() => this.handleBaseGridUpDownBtn(1)}
                    disabled={!this.state.isbaseGridDownBtn}
                  />
                )}
              {this.props.moduleStudy &&
                !this.props.moduleStudy.st
                  .toLowerCase()
                  .includes(FLEX_STUDY_TAG) && (
                  <button
                    className={`grid-up-arrow-img ${
                      this.state.isbaseGridUpBtn ? '' : 'image-disable'
                    }`}
                    onClick={() => this.handleBaseGridUpDownBtn(-1)}
                    disabled={!this.state.isbaseGridUpBtn}
                  />
                )}
            </h5>
            <ResizeAware
              style={{ position: 'relative', width: '100%' }}
              onlyEvent
              onResize={this.handleCRBGridsResize}
            >
              <DynamicDataGrid
                ref={this.basesDataGrid}
                gridCategory="BasesDataGrid"
                className="columns-data-grid dictionary-data-grid"
                gridHeight={111}
                gridWidth={this.state.CRBGridsWidth}
                headerRowHeight={28}
                rowHeight={27}
                rows={this.state.crosstabBases}
                columns={this.getGridColumns('Bases')}
                menuID={this.getBaseMenuOptions()}
                handleContextMenuOptions={this.handleContextMenuOptionsTmp}
                onGridDrop={this.handleGridDrop}
                rowSelectionType="Multi"
                handleAnswersPreview={this.props.handleAnswersPreview}
                handleRowsSelectionChange={this.handleBaseGridSelectionChange}
                onDataUpdate={rows =>
                  this.props.moduleAction.updateSampleWeighted(
                    [...rows],
                    'BasesDataGrid'
                  )
                }
                isCellSelectable
                minimunRows={3}
                hoverHandle={this.hoverHandle}
                updateCrosstabTitleHeader={this.updateCrosstabTitleHeader}
              />
            </ResizeAware>
            <h5 className="dictionary-grids-header counter-header">
              <span
                className="grid-count left-position-column"
                style={{
                  padding:
                    this.state.crosstabColumns.length < 10
                      ? '1.5px 3px'
                      : '2px',
                }}
              >
                {this.state.crosstabColumns.length}
              </span>
            </h5>
            <h5 className="cross-img-container counter-header">
              <button
                className={`cross-img ${
                  this.state.crosstabColumns.length !== 0 ? '' : 'image-disable'
                }`}
                onClick={() =>
                  this.props.moduleAction.clearSampleWeighted('ColumnsDataGrid')
                }
                disabled={this.state.crosstabColumns.length === 0}
              />
              {this.props.moduleStudy &&
                !this.props.moduleStudy.st
                  .toLowerCase()
                  .includes(FLEX_STUDY_TAG) && (
                  <button
                    className={`grid-down-arrow-img ${
                      this.state.isColumnGridDownBtn ? '' : 'image-disable'
                    }`}
                    onClick={() => this.handleColumnGridUpDownBtn(1)}
                    disabled={!this.state.isColumnGridDownBtn}
                  />
                )}
              {this.props.moduleStudy &&
                !this.props.moduleStudy.st
                  .toLowerCase()
                  .includes(FLEX_STUDY_TAG) && (
                  <button
                    className={`grid-up-arrow-img ${
                      this.state.isColumnGridUpBtn ? '' : 'image-disable'
                    }`}
                    onClick={() => this.handleColumnGridUpDownBtn(-1)}
                    disabled={!this.state.isColumnGridUpBtn}
                  />
                )}
            </h5>
            <ResizeAware
              style={{ position: 'relative', width: '100%' }}
              onlyEvent
              onResize={this.handleCRBGridsResize}
            >
              <DynamicDataGrid
                ref={this.columnsDataGrid}
                gridCategory="ColumnsDataGrid"
                className="columns-data-grid dictionary-data-grid"
                gridHeight={192}
                gridWidth={this.state.CRBGridsWidth}
                headerRowHeight={28}
                rowHeight={27}
                rows={this.state.crosstabColumns}
                columns={this.getGridColumns('Columns')}
                menuID={this.getColumnMenuOptions()}
                handleContextMenuOptions={this.handleContextMenuOptions}
                onGridDrop={this.handleGridDrop}
                rowSelectionType="Multi"
                handleAnswersPreview={this.props.handleAnswersPreview}
                handleRowsSelectionChange={this.handleColumnGridSelectionChange}
                onDataUpdate={rows =>
                  this.props.moduleAction.updateSampleWeighted(
                    [...rows],
                    'ColumnsDataGrid'
                  )
                }
                isCellSelectable
                minimunRows={6}
                hoverHandle={this.hoverHandle}
                updateCrosstabTitleHeader={this.updateCrosstabTitleHeader}
              />
            </ResizeAware>
            <h5 className="dictionary-grids-header counter-header">
              <span
                className="grid-count left-position-rows"
                style={{
                  padding:
                    this.state.crosstabRows.length < 10 ? '1.5px 3px' : '2px',
                }}
              >
                {this.state.crosstabRows.length}
              </span>
            </h5>
            <h5 className="cross-img-container counter-header">
              <button
                className={`cross-img ${
                  this.state.crosstabRows.length !== 0 ? '' : 'image-disable'
                }`}
                onClick={() =>
                  this.props.moduleAction.clearSampleWeighted('RowsDataGrid')
                }
                disabled={this.state.crosstabRows.length === 0}
              />
              {this.props.moduleStudy &&
                !this.props.moduleStudy.st
                  .toLowerCase()
                  .includes(FLEX_STUDY_TAG) && (
                  <button
                    className={`grid-down-arrow-img ${
                      this.state.isRowGridDownBtn ? '' : 'image-disable'
                    }`}
                    onClick={() => this.handleRowGridUpDownBtn(1)}
                    disabled={!this.state.isRowGridDownBtn}
                  />
                )}
              {this.props.moduleStudy &&
                !this.props.moduleStudy.st
                  .toLowerCase()
                  .includes(FLEX_STUDY_TAG) && (
                  <button
                    className={`grid-up-arrow-img ${
                      this.state.isRowGridUpBtn ? '' : 'image-disable'
                    }`}
                    onClick={() => this.handleRowGridUpDownBtn(-1)}
                    disabled={!this.state.isRowGridUpBtn}
                  />
                )}
            </h5>
            <ResizeAware
              style={{ position: 'relative', width: '100%' }}
              onlyEvent
              onResize={this.handleCRBGridsResize}
            >
              <DynamicDataGrid
                ref={this.rowsDataGrid}
                gridCategory="RowsDataGrid"
                className="columns-data-grid dictionary-data-grid last-grid"
                gridHeight={219}
                gridWidth={this.state.CRBGridsWidth}
                headerRowHeight={28}
                rowHeight={27}
                rows={this.state.crosstabRows}
                columns={this.getGridColumns('Rows')}
                menuID={this.getRowMenuOptions()}
                handleContextMenuOptions={this.handleContextMenuOptions}
                onGridDrop={this.handleGridDrop}
                rowSelectionType="Multi"
                handleAnswersPreview={this.props.handleAnswersPreview}
                handleRowsSelectionChange={this.handleRowGridSelectionChange}
                onDataUpdate={rows =>
                  this.props.moduleAction.updateSampleWeighted(
                    [...rows],
                    'RowsDataGrid'
                  )
                }
                isCellSelectable
                minimunRows={7}
                hoverHandle={this.hoverHandle}
                updateCrosstabTitleHeader={this.updateCrosstabTitleHeader}
              />
            </ResizeAware>
          </div>
        </div>
        <Modal
          title="Add to Definition..."
          ref={node => (this.addToDefinition = node)}
          dialogStyles={defineModalStyle}
        >
          <AddToDefinition
            folderName="Untitled"
            newExpressions={this.state.addToDefinition}
            handleHide={() => this.addToDefinition.hide()}
            srcScreen="QuestionsScreen"
            moduleStudy={this.props.moduleStudy}
          />
        </Modal>
        <Modal
          title="Functions"
          ref={node => (this.functionBoxModal = node)}
          dialogStyles={modalStyle}
        >
          <div className="small-12 medium-12 large-12">
            <div className="column row">
              <FunctionBox
                selectedTargets={this.state.selectedTargets}
                moveAppendToCodingBox={this.props.moveAppendToCodingBox}
                handleParentHide={() => this.functionBoxModal.hide()}
              />
            </div>
          </div>
        </Modal>
        <Modal
          title="Run Crosstab"
          ref={node => (this.addAfterRunCrosstabModal = node)}
          dialogStyles={addAfterRunCrosstabModalStyle}
        >
          <p>Only one geography base can be added.</p>
          <GenericButton
            name="OK"
            btnStyle="button display-block margin-auto"
            onBtnClick={() => this.addAfterRunCrosstabModal.hide()}
          />
        </Modal>
      </div>
    );
  }
}

CRBGridsV2.propTypes = {
  handleAnswersPreview: PropTypes.func,
  moveAppendToCodingBox: PropTypes.func,
  ColumnsDataGridData: PropTypes.arrayOf(PropTypes.object),
  RowsDataGridData: PropTypes.arrayOf(PropTypes.object),
  BasesDataGridData: PropTypes.arrayOf(PropTypes.object),
  ScratchDataGridData: PropTypes.arrayOf(PropTypes.object),
  recycleElements: PropTypes.arrayOf(PropTypes.object),
  sampleWeightedKPIs: PropTypes.shape({}),
  loginResponse: PropTypes.shape({
    data: PropTypes.shape({
      uid: PropTypes.number,
      token: PropTypes.string,
    }),
  }),
  moduleStudy: PropTypes.shape({
    pn: PropTypes.number,
    dv: PropTypes.number,
    wt: PropTypes.number,
    st: PropTypes.string,
  }),
  dictionaryTarget: PropTypes.shape({
    data: PropTypes.arrayOf(PropTypes.shape({})),
  }),
  moduleAction: PropTypes.shape({
    getSampleWeighted: PropTypes.func,
    updateSampleWeighted: PropTypes.func,
    clearSampleWeighted: PropTypes.func,
    getSampleWeightedData: PropTypes.func,
    updateCrosstabGridTitleHeader: PropTypes.func,
  }),
  dictionaryActions: PropTypes.shape({
    getDictionaryTargetLoad: PropTypes.func,
  }),
  activeAccountId: PropTypes.number,
  trackerFn: PropTypes.func,
  moduleWeigthType: PropTypes.shape({
    wt: PropTypes.number,
    dv: PropTypes.number,
  }),
  scratchEnabled: PropTypes.bool,
  breadcrumbFlag: PropTypes.bool,
  allFeatures:PropTypes.arrayOf(PropTypes.array),
};

function mapStateToProps(state) {
  return {
    loginResponse: state.login.loginResponse,
    activeAccountId: state.account.activeAccountId,
    dictionaryTarget: state.dictionary.dictionaryTarget,
    allFeatures: state.userDetail.allFeatures,
  };
}

function mapDispatchToProps(dispatch) {
  return {
    dictionaryActions: bindActionCreators(dictionaryActions, dispatch),
  };
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(CRBGridsV2);
